<template>
  <div class="api-panel">
    <h3 class="endpoint">
      <slot name="endpoint">{{ endpoint }}</slot>
    </h3>
    <UiButton
      v-for="meth in methods" :key="meth"
      @click="send(meth)"
    >
      {{ meth }}
    </UiButton>
    <div class="description"><slot name="description" /></div>
    <div class="body"><slot name="body" /></div>
    <div class="results">
      <div class="left">
        <h4>Request</h4>
        <pre v-if="request" class="request">{{ request }}</pre>
      </div>
      <div class="right">
        <h4>Response</h4>
        <div class="center">
          <UiProgressCircular v-if="loading" />
        </div>
        <pre v-if="response" class="response">{{ response }}</pre>
        <pre v-if="error" class="error">{{ error }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { UiButton, UiProgressCircular } from 'keen-ui';
import axios from 'axios';
import _ from 'lodash';

export default {
  name: 'ApiPanel',
  props: {
    endpoint: String,
    methods: Array,
    token: String,
    body: [Array, Object],
  },
  data() {
    return {
      loading: false,
      request: null,
      response: null,
      error: null,
    };
  },
  components: {
    UiButton,
    UiProgressCircular,
  },
  methods: {
    async send(meth) {
      this.loading = true;
      this.request = {
        method: meth,
        url: this.endpoint,
        data: this.body,
        headers: {
          Authorization: `Bearer ${this.token}`,
          'Content-Type': this.body ? 'application/json' : undefined,
        },
      };
      const p = axios(this.request);
      try {
        const resp = await p;
        this.error = null;
        this.response = _.omit(resp, ['config', 'request']);
      } catch (e) {
        this.response = null;
        this.error = _.omit(e.response, ['config', 'request']);
      }
      this.loading = false;
      this.$emit('updateHeight');
    },
  },
};
</script>

<style lang="scss">
.api-panel {
  .endpoint {
    display: inline-block;
  }
  pre, .description, .body {
    text-align: left;
  }
  pre, .body textarea {
    font-family: "Lucida Console", Monaco, monospace !important;
  }
  .center {
    margin: 0 auto;
    width: 0;
    width: fit-content;
  }
  .results {
    display: flex;
    .left, .right {
      width: 50%;
      overflow: scroll;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ApiPanel.vue